import '@fortawesome/fontawesome-free/css/all.min.css'
import 'bootstrap-css-only/css/bootstrap.min.css'
import 'mdbvue/lib/css/mdb.min.css'
import 'mdbvue/lib/css/mdb.css'




import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'


import axios from 'axios'
import VueAxios from 'vue-axios'
//import VueSanitize from "vue-sanitize";
import api from "./api"
import NProgress from 'nprogress'

import VueAnalytics from 'vue-analytics'

import VueKeycloakJs from '@dsb-norge/vue-keycloak-js'

//let defaults = VueSanitize.defaults;

//defaults.allowedTags = defaults.allowedTags.concat(['img']);

axios.defaults.crossDomain = true;


Vue.config.productionTip = false


Vue.prototype.$http = api;
//api.defaults.timeout = 10000;
api.interceptors.request.use(
  config => {
    NProgress.start()
    for (var i = 0; i < 3; i++) {
      NProgress.inc()
    }
    return config;
  },
  error => {
    return Promise.reject(error); //TODO Dan
  }
);
api.interceptors.response.use(
  response => {
    NProgress.done()
    return response
  },
  error => {
    if (error.response.status) { //TODO Dan
      switch (error.response.status) {
        case 400:

          //do something
          break;

        case 401:
          alert("session expired");
          router.replace({
            path: "/login",
            query: { redirect: router.currentRoute.fullPath }
          });
          break;
        case 403:
          router.replace({
            path: "/login",
            query: { redirect: router.currentRoute.fullPath }
          });
          break;
        case 404:
          router.replace({
            path: "/404",
          });
          break;
        case 502:
          setTimeout(() => {
            router.replace({
              path: "/login",
              query: {
                redirect: router.currentRoute.fullPath
              }
            });
          }, 1000);
      }
      return Promise.reject(error.response);
    }
  }
);

//axios.defaults.baseURL = "http://192.54.123.93/api/v2"
//axios.defaults.baseURL = "http://localhost/api/v2/"

import Notify from 'mdbvue/lib/components/Notify'

function tokenInterceptor(keycloak) {
  if (keycloak.authenticated) {
    console.log("in")
    api.interceptors.request.use(config => {
      config.headers.Authorization = `Bearer ${Vue.prototype.$keycloak.token}`
      return config
    }, error => {
      return Promise.reject(error)
    })
  }
}

Vue.use(VueKeycloakJs, {
  init: {
    // Use 'login-required' to always require authentication
    // If using 'login-required', there is no need for the router guards in router.js
    onLoad: 'check-sso'
  },
  config: {
    url: 'https://washoetribe.us/auth',
    clientId: 'webapp',
    realm: 'washoetribe'
  },
  onReady: (keycloak) => {
    console.log(`I wonder what Keycloak returns: ${keycloak}`)
    tokenInterceptor(keycloak)

    /* eslint-disable no-new */
    new Vue({
      router,
      store,
      VueAxios,
      render: h => h(App)
    }).$mount('#app')
  }
});
// Vue.use(VueSanitize, defaults);


// new Vue({
//   router,
//   store,
//   VueAxios,
//   render: h => h(App)
// }).$mount('#app')


Vue.use(Notify)

Vue.use(VueAnalytics, {
  id: 'UA-108942218-2'
})

//Vue.use(VueSanitize, defaults);

export const bus = new Vue();


